import { Text } from 'foundations-components/components/Text';
import PortalIdParser from 'PortalIdParser';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Flex } from 'foundations-components/components/Flex';
import { Button } from 'foundations-components/transitional/components/Button';
import { getFullUrl } from 'hubspot-url-utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function CopySuccess() {
  const settingsHref = `${getFullUrl('app')}/settings/${PortalIdParser.get()}/multi-account/asset-copier`;
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    flexDirection: "column",
    "data-test-id": "asset-copier-panel-copy-success",
    children: [/*#__PURE__*/_jsx(Illustration, {
      name: "copy-paste",
      height: 150
    }), /*#__PURE__*/_jsx(Text, {
      as: "h4",
      marginBlockStart: "500",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ui-multi-account-asset-copier.panel.copySuccess.title"
      })
    }), /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ui-multi-account-asset-copier.panel.copySuccess.description"
      })
    }), /*#__PURE__*/_jsx(Button, {
      use: "secondary",
      href: settingsHref,
      external: true,
      "data-test-id": "asset-copier-panel-settings-link",
      marginBlockStart: "200",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ui-multi-account-asset-copier.panel.copySuccess.cta"
      })
    })]
  });
}
export default CopySuccess;